module.exports = "<div>\n  <ul>\n    <li *ngFor=\"let bracelet of bracelets\" class=\"bracelet\" [style.background-color]=\"bracelet.rgb\" (click)=\"select(bracelet.$key)\"></li>\n  </ul>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Proyectos-Ankaa/proyecto-meriendas-diverland/src/app/reception/components/bracelet-picker/bracelet-picker.component.html
// module id = ../../../../../src/app/reception/components/bracelet-picker/bracelet-picker.component.html
// module chunks = main